export const RoutePath = {
    // Main routes
    Home: '/',
    Onboarding: '/onboarding',
    // Authentication routes
    Login: '/login',
    Signup: '/signup',
    ForgotPassword: '/forgot-password',
    ResetPassword: '/reset-password',
    VerifyEmail: '/verify-email',
    StripeAccountCreation: '/stripe-account-creation',
    // Account settings routes
    AccountSettings: '/account-settings',
    AccountSettingsProfile: '/account-settings/profile',
    AccountSettingsGeneral: '/account-settings/general',
    AccountSettingsIntegrations: '/account-settings/integrations',
    AccountSettingsChannels: '/account-settings/channels',
    AccountSettingsCompanies: '/account-settings/companies',
    AccountSettingsBrands: '/account-settings/brands',
    AccountSettingsUsers: '/account-settings/users',
    // Microsites routes
    Microsites: '/microsites',
    // Contacts routes
    Contacts: '/contacts',
    // Social routes
    Social: '/social',
    SocialPosts: '/social/posts',
    SocialAnalytics: '/social/analytics',
    // Reviews routes
    Reviews: '/reviews',
    ReviewsManage: '/reviews/manage',
    ReviewsAnalytics: '/reviews/analytics',
    ReviewsAnalyticsReviews: '/reviews/analytics/reviews',
    ReviewsAnalyticsKeywords: '/reviews/analytics/keywords',
    ReviewsAutomation: '/reviews/automation',
    ReviewsAutomationTemplates: '/reviews/automation/templates',
    ReviewsAutomationAutoReplies: '/reviews/automation/auto-replies',
    ReviewsWidgets: '/reviews/widgets',
    // Surveys routes
    Surveys: '/surveys',
    SurveysResponses: '/surveys/responses',
    SurveysTemplates: '/surveys/templates',
    SurveysAnalytics: '/surveys/analytics',
    SurveysAnalyticsConversion: '/surveys/analytics/conversion',
    SurveysAnalyticsResponses: '/surveys/analytics/responses',
    // Messaging routes
    Messaging: '/messaging',
    MessagingInbox: '/messaging/inbox',
    MessagingPulseAI: '/messaging/pulse-ai',
    MessagingPulseAIAgents: '/messaging/pulse-ai/agents',
    MessagingPulseAIKnowledgeBase: '/messaging/pulse-ai/knowledge-base',
    MessagingAnalytics: '/messaging/analytics',
    // Campaigns routes
    Campaigns: '/campaigns',
    CampaignsOneTime: '/campaigns/one-time',
    CampaignsAutomated: '/campaigns/automated',
    // Presence routes
    Presence: '/presence',
    PresenceProfiles: '/presence/profiles',
    PresenceMedia: '/presence/media',
    PresenceAnalytics: '/presence/analytics',
    // Coupons routes
    Coupons: '/coupons',
    // Error routes
    Error: '/error',
    // Catch-all route
    NotFound: '*',
};

export const ExternalRoutes = {
    // Apple Business Connect
    AppleBusinessConnectLink: 'https://businessconnect.apple.com/',
    AppleBusinessConnectInstructions:
        'https://support.apple.com/guide/apple-business-connect/share-access-with-a-third-party-partner-abcb3f4a4f2f/web#aria-abcb91206c97',
    // Google Services
    GoogleBusinessLocations: 'https://business.google.com/locations',
    GoogleBusinessGroups: accountId => `https://business.google.com/groups/${accountId}/locations`,
    // Pluspoint Services
    ReferralProgram: 'https://referral.pluspoint.io/',
    SupportForm: 'https://share.hsforms.com/1VAYqLOrmS7K3bD-dCdxdoA5jjzz',
    // Help Center
    HelpCenter: {
        GB: 'https://pluspoint.notion.site/Help-Center-04ab5ad456f148c3aa7c079f7c4711f5',
        ES: 'https://pluspoint.notion.site/Help-Center-ES-60e61ca791c04b65b160f508fe422c6d',
        PT: 'https://pluspoint.notion.site/Help-Center-PT-5fb5ca9f13fa4671a0ef656f16ae973f',
        UA: 'https://pluspoint.notion.site/Help-Center-UK-e685fa7caca14eeaa268982eb3d4d172',
    },
    // API Integration Documentation
    ApiIntegrationDocs: {
        GB: 'https://pluspoint.notion.site/04f71770bcf34578b7df44a020603eaa',
        ES: 'https://pluspoint.notion.site/58d59aed334043e7b70a540f5c67c581',
        PT: 'https://pluspoint.notion.site/16b6bbc063d3422a91c5f3a9b92417ba',
        UA: 'https://pluspoint.notion.site/641fbe2ac16241b1a02dbdc368f932f7',
    },
    // Learn More Links
    LearnMore: {
        GB: {
            google: 'https://pluspoint.notion.site/9e312778e83d477cb1900edd6b50482b#88cbb6d39e66494e989702e6881f2c61',
            brand: 'https://pluspoint.notion.site/5cb58cb4d53c4b28a51c9d0620254f66',
            channels: 'https://pluspoint.notion.site/9e312778e83d477cb1900edd6b50482b#18ca4ab3d25d470a9f4b8df040cd1796',
            templates:
                'https://pluspoint.notion.site/9e312778e83d477cb1900edd6b50482b#213dcb64e8314adb923e47ea885ab27c',
            autoReplies:
                'https://pluspoint.notion.site/db71ad8e93fc4162b55838f8f2d7cf0d#1a2ad0e922804e00a74762011ee991fc',
            users: 'https://pluspoint.notion.site/9e312778e83d477cb1900edd6b50482b#509676b257fc4890aead1321bd14eee3',
        },
        ES: {
            google: 'https://pluspoint.notion.site/6a8b73efdc104c028ec2e5a0b0265474#1b2a270c72454e79ba2af1a02e49e5a0',
            brand: 'https://pluspoint.notion.site/6861361cf1b64dbea1bd2146588ad236',
            channels: 'https://pluspoint.notion.site/6a8b73efdc104c028ec2e5a0b0265474#545ff57d4c854ea8b5601a7982c4a458',
            templates:
                'https://pluspoint.notion.site/6a8b73efdc104c028ec2e5a0b0265474#de4dc8ddc4dd4deaa32c4a1001e8729b',
            autoReplies:
                'https://pluspoint.notion.site/1d19710e9ee846f8a7a50d215c7261f9#0bc83b35263c4fac8e4bf5011c8e9f82',
            users: 'https://pluspoint.notion.site/6a8b73efdc104c028ec2e5a0b0265474#f2091fdeacb647ef9e4dd5e4a898ccb7',
        },
        PT: {
            google: 'https://pluspoint.notion.site/0030b0361cd44f139eec247bdf7857a3#884de7951f9340a0b3e9744ab61d8281',
            brand: 'https://pluspoint.notion.site/5cb58cb4d53c4b28a51c9d0620254f66',
            channels: 'https://pluspoint.notion.site/0030b0361cd44f139eec247bdf7857a3#18ca4ab3d25d470a9f4b8df040cd1796',
            templates:
                'https://pluspoint.notion.site/0030b0361cd44f139eec247bdf7857a3#213dcb64e8314adb923e47ea885ab27c',
            autoReplies:
                'https://pluspoint.notion.site/1d19710e9ee846f8a7a50d215c7261f9#0bc83b35263c4fac8e4bf5011c8e9f82',
            users: 'https://pluspoint.notion.site/0030b0361cd44f139eec247bdf7857a3#509676b257fc4890aead1321bd14eee3',
        },
        UA: {
            google: 'https://pluspoint.notion.site/0030b0361cd44f139eec247bdf7857a3#884de7951f9340a0b3e9744ab61d8281',
            brand: 'https://pluspoint.notion.site/5cb58cb4d53c4b28a51c9d0620254f66',
            channels: 'https://pluspoint.notion.site/0030b0361cd44f139eec247bdf7857a3#18ca4ab3d25d470a9f4b8df040cd1796',
            templates:
                'https://pluspoint.notion.site/0030b0361cd44f139eec247bdf7857a3#213dcb64e8314adb923e47ea885ab27c',
            autoReplies:
                'https://pluspoint.notion.site/1d19710e9ee846f8a7a50d215c7261f9#0bc83b35263c4fac8e4bf5011c8e9f82',
            users: 'https://pluspoint.notion.site/0030b0361cd44f139eec247bdf7857a3#509676b257fc4890aead1321bd14eee3',
        },
    },
    // Integration Learn More Links
    IntegrationLearnMore: {
        GB: 'https://pluspoint.notion.site/9e312778e83d477cb1900edd6b50482b',
        ES: 'https://pluspoint.notion.site/6a8b73efdc104c028ec2e5a0b0265474',
        PT: 'https://pluspoint.notion.site/0030b0361cd44f139eec247bdf7857a3',
        UA: 'https://pluspoint.notion.site/0030b0361cd44f139eec247bdf7857a3',
    },
    VTEXInstructions: 'https://help.pluspoint.io/en/articles/7971010-connect-vtex-account',
    // Signup Links
    SignupLink: {
        GB: 'https://www.pluspoint.io/signup',
        ES: 'https://www.pluspoint.io/es/signup',
        PT: 'https://www.pluspoint.io/pt/signup',
        UA: 'https://www.pluspoint.io/signup',
    },
    TermsLink: 'https://www.pluspoint.io/legal/terms',
    PrivacyLink: 'https://www.pluspoint.io/legal/privacy',
    DPALink: 'https://www.pluspoint.io/legal/dpa',
};
